import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../i18n/LanguageContext';
import { PRODUCTS } from '../../data/products';
import { EMAIL, PHONE_DISPLAY, PHONE_TEL, WHATSAPP } from '../../data/contact';
import logo from '../../assets/images/logo-kalyani.png';

export default function SiteFooter() {
  const { lang, t } = useLang();
  return (
    <footer className="bg-[#0A1228] text-slate-400 text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div>
          <span className="inline-block bg-white rounded-lg p-1"><img src={logo} alt="Kalyani Consultancy" className="h-9" loading="lazy" /></span>
          <p className="mt-3">{t('ftAbout')}</p>
          <p className="mt-3 space-y-1">
            <a href={PHONE_TEL} className="block hover:text-white">📞 {PHONE_DISPLAY}</a>
            <a href={WHATSAPP} className="block hover:text-white">💬 WhatsApp</a>
            <a href={`mailto:${EMAIL}`} className="block hover:text-white break-all">✉ {EMAIL}</a>
          </p>
        </div>
        <div>
          <div className="text-white font-semibold mb-3">{t('ftServices')}</div>
          <ul className="space-y-1.5">
            {PRODUCTS.map((p) => <li key={p.id}><Link to={`/services/${p.id}`} className="hover:text-white">{p[lang].title}</Link></li>)}
            <li><Link to="/investments" className="hover:text-white">{t('tMf')}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-white font-semibold mb-3">{t('ftCompany')}</div>
          <ul className="space-y-1.5">
            {[['/about', 'navAbout'], ['/calculators', 'navTools'], ['/mutual-funds', 'fundDash'], ['/pay-premium', 'pay'], ['/gallery', 'gallery'], ['/contact', 'navContact']].map(([to, k]) => (
              <li key={to}><Link to={to} className="hover:text-white">{t(k)}</Link></li>
            ))}
          </ul>
          <div className="text-white font-semibold mt-6 mb-3">{t('ftReg')}</div>
          <ul className="space-y-1.5 text-xs leading-relaxed">
            <li>{t('irdai')}</li><li>{t('arn')}</li><li>{t('grievance')}</li>
            <li><a className="underline hover:text-white" href="https://bimabharosa.irdai.gov.in" target="_blank" rel="noopener noreferrer">{t('bima')}</a></li>
          </ul>
        </div>
        <div className="text-xs leading-relaxed space-y-3">
          <p className="text-amber-200/90">⚠ {t('fraud')}</p>
          <p>{t('mfRisk')} {t('solicit')}</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 px-4 text-center text-xs flex flex-wrap justify-center gap-x-3 gap-y-1">
        <span>© {new Date().getFullYear()} Kalyani Consultancy</span>
        <Link to="/privacy-policy" className="hover:text-white">{t('privacy')}</Link>
        <Link to="/terms-and-conditions" className="hover:text-white">{t('terms')}</Link>
        <Link to="/data-deletion" className="hover:text-white">{t('dataDel')}</Link>
      </div>
    </footer>
  );
}
